import { db, firebaseImport, auth } from '@/js/external-js/config/main_config';
import { getAuthUID } from '@/lib/authState';
import { InterestedParty } from '@/interfaces/interestedParties.interface';

export async function saveInterestedPartyEdit(companyID: string, partyID: string, updatedParty: InterestedParty) {
  // Save to both locations
  const managementRegisterRef = db.doc(`/customers/${companyID}/product/managementSystemGuide/interestedPartiesRegister/register`);
  const ismsManualRef = db.doc(`/customers/${companyID}/product/policyPackages/ISO27001keyDocuments/ismsManual`);

  try {
    // First, check if the document exists
    const doc = await managementRegisterRef.get();
    
    if (doc.exists) {
      // Document exists, update it
      await managementRegisterRef.update({
        [`${partyID}`]: updatedParty
      });
    } else {
      // Document doesn't exist, create it with the party data
      await managementRegisterRef.set({
        [partyID]: updatedParty
      });
    }

    // Update the ISMS manual document (same logic as above)
    const ismsDoc = await ismsManualRef.get();
    if (ismsDoc.exists) {
      await ismsManualRef.update({
        [`partiesInterested.${partyID}`]: updatedParty
      });
    } else {
      await ismsManualRef.set({
        partiesInterested: {
          [partyID]: updatedParty
        }
      });
    }
  } catch (error) {
    console.error('Error saving interested party:', error);
    throw error;
  }
}

export function getCurrentUserId() {
  return getAuthUID() || '';
}

export function getFirestoreTimestamp(date: string | Date) {
  if (typeof date === 'string') {
    return firebaseImport.firestore.Timestamp.fromDate(new Date(date));
  }
  return firebaseImport.firestore.Timestamp.fromDate(date);
}
